"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizeToIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const providers_1 = require("../../providers");
exports.sizeToIcon = {
    3: ui_1.Icons.Fracture_Size_0,
    2: ui_1.Icons.Fracture_Size_1,
    1: ui_1.Icons.Fracture_Size_2,
    0: ui_1.Icons.Fracture_Size_3,
};
const BUTTON_OFFSET = 70;
function FractureSizes({ sizes, active, className, size, onChange, }) {
    const bridge = (0, bridge_1.useBridge)();
    const tools = (0, providers_1.useToolsService)();
    const fractureManager = tools === null || tools === void 0 ? void 0 : tools.getThreeDToolManager();
    const onSelect = (value) => {
        fractureManager === null || fractureManager === void 0 ? void 0 : fractureManager.updateFractureOptions({
            size: value,
        });
        onChange(value);
        bridge === null || bridge === void 0 ? void 0 : bridge.toolUpdateFracture({ size: value });
        bridge === null || bridge === void 0 ? void 0 : bridge.toolkitOptionsAction({
            optionType: 1,
            size: value,
            type: bridge_schema_1.ToolType.FractureSimple,
        });
    };
    return ((0, jsx_runtime_1.jsx)(Container, { className: className, "data-e2e": 'FractureSizes_Container', children: sizes.map((value, index) => {
            const offset = (index + 1) * BUTTON_OFFSET;
            return ((0, jsx_runtime_1.jsx)(ButtonContainer, { active: active, offset: offset, "data-e2e": 'FractureSizes_ButtonContainer', children: (0, jsx_runtime_1.jsx)(ui_1.PushInAnimation, { delay: 200, "data-e2e": 'FractureSizes_PushInAnimation', children: (0, jsx_runtime_1.jsx)(Button, { selected: value === size, onClick: () => onSelect(value), className: "fractureSizeButton", "data-e2e": 'FractureSizes_Button', children: (0, jsx_runtime_1.jsx)(ButtonIcon, { name: exports.sizeToIcon[value], "data-e2e": 'FractureSizes_ButtonIcon' }) }) }) }, index));
        }) }));
}
exports.default = FractureSizes;
const Container = styled_components_1.default.div `
  display: flex;

  padding: 5px 0;

  overflow: hidden;
`;
const ButtonContainer = styled_components_1.default.div `
  margin: auto 0;

  transform: translateX(
    ${({ active, offset }) => (active ? '0' : `-${offset}px`)}
  );

  transition: transform 0.3s;
`;
const Button = (0, styled_components_1.default)(ui_1.BaseButton) `
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 40px;
  height: 40px;

  margin: auto 30px auto 0;
  padding: 0;

  color: ${props => props.theme.toolkit.menu.icon.deselected};

  background-color: ${props => props.selected ? props.theme.tools.fracture.background : 'none'};

  border-radius: 50%;
`;
const ButtonIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 30px;
  height: 30px;
`;
